// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-leads-wrapper {
  width: 100%;
}
.add-leads-wrapper .steps-wrapper .icon-wrapper {
  background: #BCBCBC;
  border-radius: 50%;
  width: 42px;
  height: 42px;
}
.add-leads-wrapper .steps-wrapper .icon-wrapper.active {
  background: #D0566E;
}
.add-leads-wrapper .steps-wrapper .line-dash {
  color: #BCBCBC;
}
.add-leads-wrapper .steps-wrapper .line-dash.active {
  color: #D0566E;
}
.add-leads-wrapper .steps-wrapper .step-name-wrapper {
  width: 110%;
}
.add-leads-wrapper .steps-wrapper .step-name-wrapper .step-name {
  font-size: 14px;
  font-weight: 400;
  color: #3a3a3a;
}
.add-leads-wrapper .steps-wrapper .step-name-wrapper .step-name.active {
  color: #D0566E;
  font-weight: 700;
  cursor: pointer;
}
.add-leads-wrapper .steps-wrapper .step-name-wrapper .step-name.thin-text {
  color: #D0566E;
  font-weight: 400;
  cursor: pointer;
}

.search-global {
  background-color: transparent;
  box-shadow: none;
  border: none;
  outline: none;
  padding: 0;
  border-radius: 0;
  line-height: 1px;
}

.search-global-cont {
  border-bottom: 1px solid #d0566e;
}

td.tableContent {
  padding-bottom: 12px;
}

th.tableContent {
  font-weight: 400;
}

tr.tableRow {
  cursor: pointer;
}

tr.tableRow:hover {
  background: #f3f3f3;
}

.customer-account-source .selected-item {
  padding: 0;
}
.customer-account-source .options-container {
  max-height: 92px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddLeads/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAGI;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AADN;AAGM;EACE,mBAAA;AADR;AAMI;EACE,cAAA;AAJN;AAMM;EACE,cAAA;AAJR;AAQI;EACE,WAAA;AANN;AAOM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALR;AAOQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AALV;AAQQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AANV;;AAcA;EACE,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,gCAAA;AAXF;;AAcA;EACE,oBAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAeE;EACE,UAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ","sourcesContent":[".add-leads-wrapper {\n  width: 100%;\n  // height: 100%;\n\n  .steps-wrapper {\n    .icon-wrapper {\n      background: #BCBCBC;\n      border-radius: 50%;\n      width: 42px;\n      height: 42px;\n\n      &.active {\n        background: #D0566E;\n\n      }\n    }\n\n    .line-dash {\n      color: #BCBCBC;\n\n      &.active {\n        color: #D0566E;\n      }\n    }\n\n    .step-name-wrapper{\n      width: 110%;\n      .step-name {\n        font-size: 14px;\n        font-weight: 400;\n        color: #3a3a3a;\n  \n        &.active {\n          color: #D0566E;\n          font-weight: 700;\n          cursor: pointer;\n        }\n  \n        &.thin-text {\n          color: #D0566E;\n          font-weight: 400;\n          cursor: pointer;\n        }\n      }\n    }\n\n  }\n}\n\n.search-global {\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n  outline: none;\n  padding: 0;\n  border-radius: 0;\n  line-height: 1px\n}\n\n.search-global-cont {\n  border-bottom: 1px solid #d0566e;\n}\n\ntd.tableContent {\n  padding-bottom: 12px;\n}\n\nth.tableContent {\n  font-weight: 400;\n}\n\ntr.tableRow {\n  cursor: pointer;\n}\n\ntr.tableRow:hover {\n  background: #f3f3f3;\n}\n\n.customer-account-source{\n  .selected-item{\n    padding: 0;\n  }\n\n  .options-container{\n    max-height: 92px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
